import type { QueryClient } from '@tanstack/react-query';

const DEFAULT_INVALIDATION_DELAY = 300; // ms
const timers = new Map<string, ReturnType<typeof setTimeout>>();

export function scheduleInvalidation(
  queryClient: QueryClient,
  deviceId: string,
  queryKeys: string[],
  delay = DEFAULT_INVALIDATION_DELAY,
): void {
  for (const key of queryKeys) {
    const id = `${deviceId}::${key}`;
    const existing = timers.get(id);
    if (existing) clearTimeout(existing);
    timers.set(
      id,
      setTimeout(() => {
        timers.delete(id);
        void queryClient.invalidateQueries({
          predicate: (query) => {
            const { queryKey } = query;
            if (!Array.isArray(queryKey) || queryKey[0] !== key) return false;
            const params = (queryKey[1] ?? {}) as { deviceId?: string };
            return params.deviceId === deviceId;
          },
        });
      }, delay),
    );
  }
}

/** Cancel all pending invalidations (for tests). */
export function cancelAllScheduled(): void {
  for (const timer of timers.values()) clearTimeout(timer);
  timers.clear();
}
